import { render, staticRenderFns } from "./add-user.vue?vue&type=template&id=fa2312d8&scoped=true"
import script from "./add-user.vue?vue&type=script&lang=js"
export * from "./add-user.vue?vue&type=script&lang=js"
import style0 from "./add-user.vue?vue&type=style&index=0&id=fa2312d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2312d8",
  null
  
)

export default component.exports